import { CSSProperties } from 'styled-components'
import React from 'react'
import { Icon, Popup, PopupProps } from 'semantic-ui-react'
import { useFormContext } from 'react-hook-form'

interface Props {
  style?: CSSProperties
  name?: string
  control?: any;
  valueField?: string | number
}

const WarningIcon:React.FC<Props & PopupProps> = (props) => {
  const { style, name, control, valueField, ...popupProps } = props
  const { formState: { errors }, getValues } = useFormContext()

  const hasError = Boolean(errors[name])

  const hasValue = Boolean(getValues(name)) || Boolean(valueField)

  if (!name || !control) {
    return <Popup
      {...popupProps}
      trigger={<Icon name='warning sign' color='yellow' style={{ fontSize: '1.2em', ...style }} />}
    />
  }

  if(!hasError && hasValue) {
    return <Popup
      {...popupProps}
      trigger={<Icon name='warning sign' color='yellow' style={{ fontSize: '1.2em', ...style }} />}
    />
  }

  return null
}
export default WarningIcon